const mockJson = {
  A: [
    {
      id: 32,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿拉斯加',
      breedCode: 'alaskan_husky',
      thumbnailUrl:
        'https://royalcanin-dev-internal.acxiom.com.cn/cdn-api/files/blobResource/86a91a02-0f67-4a64-8b39-f8edee39a749.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 36,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '澳大利亚凯尔皮犬',
      breedCode: 'australian_kelpie',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/澳大利亚凯尔皮犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 46,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '澳大利亚丝毛梗',
      breedCode: 'australian_silky_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/丝毛梗.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 113,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '奥弗涅指示犬',
      breedCode: 'auvergne_pointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 132,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰格伦芬犬',
      breedCode: 'irish_glen_of_imaal_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 144,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '安纳托利亚牧羊犬',
      breedCode: 'kangal_shepherd_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/安娜图牧羊犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 146,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '埃斯特雷拉山犬',
      breedCode: 'estrela_mountain_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 165,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '安达卢西亚猎犬',
      breedCode: 'ratonero_bodeguero_andaluz',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 167,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿拉斯加克利凯犬',
      breedCode: 'alaskan_klee_kai',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 202,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿彭策尔牧牛犬',
      breedCode: 'appenzell_cattle_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 203,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '奥地利黑棕猎犬',
      breedCode: 'austrian_black_and_tan_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 224,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿登牛犬',
      breedCode: 'bouvier_des_ardennes',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 235,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿里格尔犬',
      breedCode: 'ariegeois',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 236,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿里格尔犬',
      breedCode: 'ariegeois',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 266,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿迪（阿特拉斯山犬）',
      breedCode: 'atlas_mountain_dog_aidi',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 301,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿富汗猎犬',
      breedCode: 'afghan_hound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/阿富汗猎犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 308,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈士奇',
      breedCode: 'alaskan_malamute',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/阿拉斯加雪橇犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 342,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿根廷杜高犬',
      breedCode: 'dogo_argentino',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/杜高犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 352,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿克巴什犬',
      breedCode: 'akbash_dog',
      thumbnailUrl:
        'https://royalcanin-dev-internal.acxiom.com.cn/cdn-api/files/blobResource/75142079-bdeb-4380-8f35-3e00fdb94da6.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 361,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰水猎犬',
      breedCode: 'irish_water_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/爱尔兰水猎犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 369,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿沙瓦犬',
      breedCode: 'azawakh',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 374,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰狼犬',
      breedCode: 'irish_wolfhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/爱尔兰猎狼犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 378,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰红色猎鹰犬',
      breedCode: 'irish_red_setter',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 454,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿尔戈指示犬',
      breedCode: 'ariege_pointing_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 456,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '奥地利平犬',
      breedCode: 'austrian_pinscher',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 457,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '澳大利亚梗犬',
      breedCode: 'australian_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/澳洲梗.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 490,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '澳大利亚牧牛犬',
      breedCode: 'australian_cattle_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/澳洲牧牛犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 506,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰红白猎犬',
      breedCode: 'irish_red_and_white_setter',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 510,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '澳大利亚短尾牧牛犬',
      breedCode: 'australian_stumpy_tail_cattle_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 529,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱沙尼亚猎犬',
      breedCode: 'estonian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 542,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '艾尔谷梗',
      breedCode: 'airedale_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/万能梗.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 1,
      lifeStages: null,
    },
    {
      id: 548,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿兰多獒犬',
      breedCode: 'rafeiro_of_alentejo',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 558,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '澳大利亚牧羊犬',
      breedCode: 'australian_shepherd',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/澳洲牧羊犬.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 571,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰软毛小麦梗',
      breedCode: 'irish_soft_coated_wheaten_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 575,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '爱尔兰梗',
      breedCode: 'irish_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/爱尔兰梗.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 359,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿芬平犬',
      breedCode: 'affenpinscher',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/艾芬品.png',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 80,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 218,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '阿图瓦猎犬',
      breedCode: 'artois_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'A',
      isDisplay: true,
      creationDt: null,
      weight: 30,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  B: [
    {
      id: 31,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波士顿梗',
      breedCode: 'boston_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/波士顿梗.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 39,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波萨瓦茨猎犬',
      breedCode: 'posavatz_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 40,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '中型格里芬犬',
      breedCode: 'briquet_griffon_vendeen',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 41,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比格猎犬',
      breedCode: 'beagle_harrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 71,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '白色瑞士牧羊犬',
      breedCode: 'white_swiss_shepherd_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/白色牧羊犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 82,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '贝尔加马斯科牧羊犬',
      breedCode: 'bergamasco_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 83,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波旁内向导猎犬',
      breedCode: 'bourbonnais_pointing_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 89,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '冰岛牧羊犬',
      breedCode: 'icelandic_sheepdog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/冰岛牧羊犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 127,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利时牧羊犬',
      breedCode: 'belgian_shepherd_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/比利时牧羊犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 128,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波斯尼亚破毛猎犬',
      breedCode: 'bosnian_broken_haired_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 136,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利时莱肯诺牧羊犬',
      breedCode: 'belgian_laekenois_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 143,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '北因纽特犬',
      breedCode: 'northern_inuit',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 169,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '博伊金猎犬',
      breedCode: 'boykin_spaniel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 170,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比耶尔梗',
      breedCode: 'biewer_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 171,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '捕鼠梗犬',
      breedCode: 'rat_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 209,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利时马里努阿牧羊犬',
      breedCode: 'belgian_malinois_sheepdog',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/马里努阿犬(比利时玛利诺犬）.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 212,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巴西猎犬',
      breedCode: 'brazilian_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 214,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '北海道犬',
      breedCode: 'hokkaido',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 220,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巴塞特·法福·布列塔尼犬',
      breedCode: 'basset_fauve_de_bretagne',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 226,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '布尔戈斯指示犬',
      breedCode: 'burgos_pointing_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 229,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '标准贵宾犬',
      breedCode: 'poodle_royal',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 231,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比格犬',
      breedCode: 'beagle',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/比格犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 244,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利时格罗恩达尔牧羊犬',
      breedCode: 'belgian_groenendael_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 246,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巴伐利亚山地嗅觉猎犬',
      breedCode: 'bavarian_mountain_scent_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 262,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利猎犬',
      breedCode: 'billy',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 267,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巴萨猎犬',
      breedCode: 'basset_hound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/巴吉度猎犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 268,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利时特尔弗伦牧羊犬',
      breedCode: 'belgian_tervueren_sheepdog',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/比利时坦比连犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 293,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波兰猎犬',
      breedCode: 'polish_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 326,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '标准雪纳瑞犬',
      breedCode: 'schnauzer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 339,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '边境牧羊犬',
      breedCode: 'border_collie',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/边境牧羊犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 344,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '博美犬',
      breedCode: 'pomeranian',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/博美犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 353,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伯恩山犬',
      breedCode: 'bernese_mountain_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/伯恩山犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 354,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波尔多犬',
      breedCode: 'dogue_de_bordeaux',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 363,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利牛斯獒犬',
      breedCode: 'pyrenean_mastiff',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 364,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巴西獒犬',
      breedCode: 'fila_brasileiro',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 381,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '布拉格猎鼠犬',
      breedCode: 'prague_ratter',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 416,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波兰猎犬',
      breedCode: 'polish_hunting_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 438,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波兰低地牧羊犬',
      breedCode: 'polish_lowland_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 441,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利时格里芬犬',
      breedCode: 'griffon_belge',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/布鲁塞尔粗毛猎犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 455,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '布列塔尼猎犬',
      breedCode: 'brittany_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/不列塔尼猎犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 458,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伯恩山犬',
      breedCode: 'bernese_hound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/伯恩山犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 475,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '边境梗',
      breedCode: 'border_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/边境梗.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 480,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比熊犬',
      breedCode: 'bichon_frise',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/比熊犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 493,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波尔西猎犬',
      breedCode: 'porcelaine',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 505,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '布鲁塞尔格里芬犬',
      breedCode: 'griffon_bruxellois',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 507,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波兰灵缇犬',
      breedCode: 'polish_greyhound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 509,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '博洛尼亚犬',
      breedCode: 'bolognese',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 524,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '北京犬',
      breedCode: 'pekingese',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/京巴(北京犬).png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 532,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波西米亚刚毛指示格里芬犬',
      breedCode: 'bohemian_wire_haired_pointing_griffon',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 546,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '比利牛斯山犬',
      breedCode: 'pyrenean_mountain_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 555,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巴森吉犬',
      breedCode: 'basenji',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/巴仙吉.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 556,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '博斯牧羊犬',
      breedCode: 'beauce_sheep_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 559,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '布波犬',
      breedCode: 'boerbel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 564,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '波斯尼亚和黑塞哥维那克罗地亚牧羊犬',
      breedCode: 'bosnian_and_herzegovinian_croatian_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 566,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '贝林顿梗',
      breedCode: 'bedlington_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/贝灵顿梗.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 569,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伯瑞犬',
      breedCode: 'briard',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/伯瑞犬.png',
      keywords: null,
      firstLetter: 'B',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  C: [
    {
      id: 76,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '粗毛斯蒂里亚猎犬',
      breedCode: 'coarse_haired_styrian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 228,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛吉娃娃',
      breedCode: 'chihuahua_longed_haired',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 274,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛威玛猎犬',
      breedCode: 'weimaraner_longhaired',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 335,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛腊肠犬-迷你',
      breedCode: 'dachshund_long_haired_miniature',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 338,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛腊肠犬-兔型',
      breedCode: 'dachshund_long_haired_rabbit',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 365,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '柴犬',
      breedCode: 'shiba',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/柴犬.png',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 483,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛腊肠犬',
      breedCode: 'dachshund_wire_haired',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/长毛腊肠犬.png',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 519,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛腊肠犬',
      breedCode: 'dachshund_long_haired',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/长毛腊肠犬.png',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 530,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长毛比利牛斯牧羊犬',
      breedCode: 'long_haired_pyrenean_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'C',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  D: [
    {
      id: 9,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '多佛涅牧羊犬',
      breedCode: 'berger_dauvergne',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 35,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国猎犬',
      breedCode: 'german_hunting_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 58,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国刚毛指示犬',
      breedCode: 'german_wire_haired_pointing_dog',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/德国刚毛指示犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 59,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大加斯科犬',
      breedCode: 'gascon_saintongeois_great',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 72,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大瑞士山犬',
      breedCode: 'great_swiss_mountain_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/大瑞士山地犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 75,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大秘鲁无毛犬',
      breedCode: 'peruvian_hairless_dog_large',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 91,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大型葡萄牙波登哥犬',
      breedCode: 'portuguese_podengo_large',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 114,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国猎犬',
      breedCode: 'german_spaniel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 124,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大加斯科涅蓝猎犬',
      breedCode: 'great_gascony_blue',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 131,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大英法三色猎犬',
      breedCode: 'great_anglo_french_tricolour_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 140,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国短毛指示犬',
      breedCode: 'german_short_haired_pointing_dog',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/德国短毛指示犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 154,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '丹迪丁蒙特梗',
      breedCode: 'dandie_dinmont_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 158,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国平毛犬',
      breedCode: 'german_pinscher',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 200,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国猎犬',
      breedCode: 'german_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 201,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大型巴萨格里芬梵代犬',
      breedCode: 'grand_basset_griffon_vendeen',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 204,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '短毛威玛猎犬',
      breedCode: 'weimaraner_short_haired',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 207,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '丹麦指示犬',
      breedCode: 'old_danish_pointing_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 213,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德伦特猎鸟犬',
      breedCode: 'drentsche_partridge_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 221,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '东西伯利亚拉卡犬',
      breedCode: 'east_siberian_laika',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 223,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '杜宾犬',
      breedCode: 'dobermann',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/杜宾犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 230,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '达尔马提亚犬',
      breedCode: 'dalmatian',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/大麦町犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 233,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大陆玩具猎犬',
      breedCode: 'continental_toy_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/蝴蝶犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 269,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德雷弗猎犬',
      breedCode: 'drever',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 291,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大型格里芬梵代犬',
      breedCode: 'grand_griffon_vendeen',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 314,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '东欧牧羊犬',
      breedCode: 'east_european_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 316,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '丹麦尖嘴犬',
      breedCode: 'danish_spitz',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 329,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国牧羊犬',
      breedCode: 'german_shepherd',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/德国牧羊犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 341,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斗牛犬',
      breedCode: 'bull_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/牛头梗.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 366,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大型明斯特兰德犬',
      breedCode: 'large_munsterlander',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 413,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国小型狐狸犬',
      breedCode: 'german_spitz_klein',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 414,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国巨型狐狸犬',
      breedCode: 'german_spitz_giant',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 421,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '丹麦瑞典农场犬',
      breedCode: 'danish_swedish_farmdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 467,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大型英法白黑猎犬',
      breedCode: 'great_anglo_french_white_and_black_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 478,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '短毛腊肠犬-兔型',
      breedCode: 'dachshund_smooth_haired_rabbit',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 487,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '短毛牧羊犬',
      breedCode: 'collie_smooth',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 489,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国长毛指示犬',
      breedCode: 'german_longhaired_pointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 491,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大陆斗牛犬',
      breedCode: 'continental_bulldog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 502,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '图莱亚尔绒毛犬',
      breedCode: 'coton_de_tulear',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/图莱亚尔绒毛犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 503,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '德国粗毛指示犬',
      breedCode: 'deutsch_stichelhaar',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 504,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大型英法白橙猎犬',
      breedCode: 'great_anglo_french_white_orange_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 517,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '达克斯布若卡犬',
      breedCode: 'alpine_dachsbracke',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 520,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '短毛腊肠犬-迷你',
      breedCode: 'dachshund_smooth_haired_miniature',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 538,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '葡萄牙波登哥犬',
      breedCode: 'portuguese_podengo',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 547,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '大丹犬',
      breedCode: 'great_dane',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/大丹犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 560,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '丹麦布罗荷马獒',
      breedCode: 'broholmer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 561,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斗牛獒犬',
      breedCode: 'bullmastiff',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/斗牛马士提夫犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 574,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斗牛犬',
      breedCode: 'bulldog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/英国斗牛犬.png',
      keywords: null,
      firstLetter: 'D',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  E: [
    {
      id: 84,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '俄罗斯猎犬',
      breedCode: 'russie',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'E',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 102,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '恩特雷布赫山地犬',
      breedCode: 'entlebuch_cattle_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'E',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 315,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '俄罗斯彩色波隆那犬',
      breedCode: 'russkaja_tsvetnaja_bolonka',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'E',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 379,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '俄罗斯猎狼犬',
      breedCode: 'borzoi',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'E',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 541,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '俄罗斯猎犬',
      breedCode: 'russian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'E',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  F: [
    {
      id: 6,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '费斯特犬',
      breedCode: 'feist',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 57,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国指示犬-加斯科尼指示犬',
      breedCode: 'french_pointing_dog_gascogne_type',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/指示犬.png',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 112,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国黄白猎犬',
      breedCode: 'french_white_and_orange_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 155,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '芬兰猎犬',
      breedCode: 'finnish_spitz',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/芬兰猎犬.png',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 272,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国猎犬',
      breedCode: 'french_spaniel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 288,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法老猎犬',
      breedCode: 'pharaoh_hound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/法老王猎犬.png',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 303,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国斗牛犬',
      breedCode: 'french_bulldog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/法国斗牛犬.png',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 307,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国水犬',
      breedCode: 'french_water_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 323,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '芬兰拉普猎犬',
      breedCode: 'finnish_lapponian_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 419,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '弗里斯兰水犬',
      breedCode: 'frisian_water_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 440,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国三色猎犬',
      breedCode: 'french_tricolour_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 465,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国白黑猎犬',
      breedCode: 'french_white_black_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 470,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '芬兰猎犬',
      breedCode: 'finnish_hound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/芬兰猎犬.png',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 495,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国指示犬-比利牛斯山向导猎犬',
      breedCode: 'french_pointing_dog_pyrenean_type',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 539,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '法国布列塔尼格里芬犬',
      breedCode: 'fawn_brittany_griffon',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 568,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '弗兰德斯比利牛斯犬',
      breedCode: 'bouvier_des_flandres',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/法兰德斯畜牧犬.png',
      keywords: null,
      firstLetter: 'F',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  G: [
    {
      id: 65,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '光毛腊肠犬',
      breedCode: 'dachshund_smooth_haired',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 67,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '刚毛腊肠犬-迷你',
      breedCode: 'dachshund_wire_haired_miniature',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 77,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '戈登猎犬',
      breedCode: 'gordon_setter',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/哥顿雪达.png',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 325,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哥特兰猎犬',
      breedCode: 'gotlan_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 333,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '贵宾犬',
      breedCode: 'poodle',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/贵宾(泰迪).png',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 343,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '贵宾(泰迪)－中型',
      breedCode: 'medium_poodle',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 484,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '刚毛腊肠犬-兔型',
      breedCode: 'dachshund_wire_haired_rabbit',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 523,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '贵宾(泰迪)－多色',
      breedCode: 'poodle_multi_colored',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 531,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '格林兰犬',
      breedCode: 'greenland_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 545,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '高加索牧羊犬',
      breedCode: 'caucasian_shepherd_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/高加索猎狼犬.png',
      keywords: null,
      firstLetter: 'G',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  H: [
    {
      id: 30,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈巴狗',
      breedCode: 'pug',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/哈巴狗(巴哥犬).png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 55,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '荷兰库伊科犬',
      breedCode: 'nederlandse_kooikerhondje',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 78,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '汗挪威嗅猎犬',
      breedCode: 'hanoverian_scent_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 88,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈瓦那犬',
      breedCode: 'havanese',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/哈威那.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 101,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '荷兰牧羊犬',
      breedCode: 'dutch_schapendoes',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 111,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈尔登猎犬',
      breedCode: 'halden_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 137,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '韩国珍岛犬',
      breedCode: 'korea_jindo_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 168,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '混合品种犬（26-44公斤）',
      breedCode: 'mixed_breed_maxi_26_44kg',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 190,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '混合品种犬（11-25公斤）',
      breedCode: 'mixed_breed_medium_11_25kg',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 197,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '荷兰小梗犬',
      breedCode: 'schipperke',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/舒柏奇犬.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 256,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '黑色挪威猎鹿犬',
      breedCode: 'norwegian_elkhound_black',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 292,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '灰色挪威猎鹿犬',
      breedCode: 'norwegian_elkhound_grey',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 310,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '混种犬',
      breedCode: 'mixed_breed',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/串串.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 318,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '荷兰牧羊犬',
      breedCode: 'dutch_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 322,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '汉密尔顿斯多弗尔犬',
      breedCode: 'hamiltonstovare',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 355,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '霍夫瓦尔特犬',
      breedCode: 'hovawart',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 376,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '黑俄罗斯梗',
      breedCode: 'russian_black_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 383,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '红浣熊猎犬',
      breedCode: 'coonhound_redbone',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 389,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈士奇博美犬',
      breedCode: 'pomsky',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 391,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '黑嘴猎犬',
      breedCode: 'black_mouth_cur',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 426,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '黑山山地猎犬',
      breedCode: 'montenegrin_mountain_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 442,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '荷兰斯牟雄德犬',
      breedCode: 'dutch_smoushond',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 474,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '黑黄猎浣熊犬',
      breedCode: 'black_and_tan_coonhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/黑褐猎浣熊犬.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 497,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈里犬',
      breedCode: 'harrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/哈利犬.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 498,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '海根猎犬',
      breedCode: 'hygen_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 528,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '哈勒福斯驯鹿犬',
      breedCode: 'hallefors_elkhund',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 534,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '长须牧羊犬',
      breedCode: 'bearded_collie',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/古代长须牧羊犬.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 535,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '蝴蝶犬',
      breedCode: 'epagneul_nain_continental_phalene',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/蝴蝶犬.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 552,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '混合品种巨型犬（+45Kg）',
      breedCode: 'mixed_breed_giant_45kg',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 573,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '狐梗',
      breedCode: 'fox_terrier_wire',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/刚毛猎狐梗.png',
      keywords: null,
      firstLetter: 'H',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  J: [
    {
      id: 100,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '捷克牧羊犬',
      breedCode: 'bohemian_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 103,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '加泰霍拉豹犬',
      breedCode: 'catahoula_leopard_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 150,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卷毛猎回犬',
      breedCode: 'curly_coated_retriever',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/卷毛寻回犬.png',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 191,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '金毛贵宾犬',
      breedCode: 'goldendoodle',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 215,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '甲斐犬',
      breedCode: 'kai',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 239,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '加泰隆牧羊犬',
      breedCode: 'catalan_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 319,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '捷克狼犬',
      breedCode: 'czechoslovakian_wolfdog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国混血狼.png',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 332,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '金毛寻回犬',
      breedCode: 'golden_retriever',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/金毛寻回犬.png',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 347,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '加那利犬',
      breedCode: 'presa_canario',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 362,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '捷克梗',
      breedCode: 'cesky_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 377,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '巨型雪纳瑞犬',
      breedCode: 'giant_schnauzer',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/巨型雪那瑞.png',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 385,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '金塔马尼巴厘犬',
      breedCode: 'kintamani_bali_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 388,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '加拿大爱斯基摩犬',
      breedCode: 'canadian_eskimo_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 476,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '加那利沃伦猎犬',
      breedCode: 'canarian_warren_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 481,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '吉娃娃',
      breedCode: 'chihuahua',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 485,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '杰克罗素梗',
      breedCode: 'jack_russell_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/杰克罗素梗.png',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 488,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迦南犬',
      breedCode: 'canaan_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/卡南犬.png',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 565,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '纪州犬',
      breedCode: 'kishu',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'J',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  K: [
    {
      id: 12,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '可卡布犬',
      breedCode: 'cockapoo',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 60,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '克罗姆弗兰德犬',
      breedCode: 'kromfohrlander',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 118,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '凯斯霍德犬',
      breedCode: 'keeshond',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/荷兰毛狮犬.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 120,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '科尔塔尔硬毛指示犬',
      breedCode: 'wire_haired_pointing_griffon_korthals',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 270,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '凯恩梗犬',
      breedCode: 'cairn_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/凯安梗.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 271,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卡累利阿猎熊犬',
      breedCode: 'karelian_bear_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 370,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '凯里蓝梗',
      breedCode: 'kerry_blue_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/凯利蓝梗.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 393,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卡罗莱纳犬',
      breedCode: 'carolina_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 436,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卡尔斯特牧羊犬',
      breedCode: 'karst_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 437,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '库瓦兹犬',
      breedCode: 'kuvasz',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/库瓦斯犬.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 464,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卡斯特劳博雷罗犬',
      breedCode: 'castro_laboreiro_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 466,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '克罗地亚牧羊犬',
      breedCode: 'croatian_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 526,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卡瓦利尔查尔斯王小猎犬',
      breedCode: 'cavalier_king_charles_spaniel',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/骑士查理王猎犬.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 550,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '可蒙多犬',
      breedCode: 'komondor',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/可蒙犬.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 554,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '克伦伯犬',
      breedCode: 'clumber_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/克伦伯猎鹬犬.png',
      keywords: null,
      firstLetter: 'K',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  L: [
    {
      id: 11,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '蓝点浣熊犬',
      breedCode: 'bluetick_coonhoud',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 14,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '拉布拉多德利犬',
      breedCode: 'labradoodle',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 47,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '蓝皮卡第猎犬',
      breedCode: 'blue_picardy_spaniel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 66,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '腊肠犬',
      breedCode: 'dachshund',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 73,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '罗马尼亚米奥里提克牧羊犬',
      breedCode: 'romanian_mioritic_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 110,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '兰开夏赫勒犬',
      breedCode: 'lancashire_heeler',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 145,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '莱昂贝格犬',
      breedCode: 'leonberg',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 147,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '罗威纳犬',
      breedCode: 'rottweiler',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/罗威纳犬.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 159,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '莱克兰梗',
      breedCode: 'lakeland_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/湖畔梗.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 164,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '罗德西亚脊背犬',
      breedCode: 'rhodesian_ridgeback',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/罗得西亚脊背犬.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 174,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卢卡斯梗',
      breedCode: 'lucas_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 194,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '老式英国牧羊犬',
      breedCode: 'old_english_sheepdog',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/古代英国牧羊犬.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 196,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '罗马尼亚喀尔巴阡牧羊犬',
      breedCode: 'romanian_carpathian_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 205,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '拉普兰牧羊犬',
      breedCode: 'lapponian_herder',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 225,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '蓝色加斯科涅猎犬',
      breedCode: 'blue_gascony_basset',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 251,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '罗曼娜水犬',
      breedCode: 'romagna_water_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 264,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '蓝色加斯科涅格里芬犬',
      breedCode: 'blue_gascony_griffon',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 273,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '鹿猎犬',
      breedCode: 'deerhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/苏格兰猎鹿犬.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 290,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '卢塞恩猎犬',
      breedCode: 'lucerne_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 302,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '拉萨犬',
      breedCode: 'lhasa_apso',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/拉萨犬.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 327,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '拉布拉多猎犬',
      breedCode: 'labrador_retriever',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/拉布拉多寻回犬.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 356,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '灵缇犬',
      breedCode: 'greyhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/灵缇.png',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 412,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '罗马尼亚布科维纳牧羊犬',
      breedCode: 'ciobanesc_romanesc_de_bucovina',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 508,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '老式英国斗牛犬',
      breedCode: 'old_english_bulldog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'L',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  M: [
    {
      id: 4,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国无毛梗',
      breedCode: 'american_hairless_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 5,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你混血犬（4-10kg）',
      breedCode: 'mixed_breed_mini_4_10kg',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 29,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国恶霸犬',
      breedCode: 'american_bully',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国恶霸犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 48,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国爱斯基摩犬',
      breedCode: 'american_eskimo',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国爱斯基摩犬-标准.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 61,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国爱斯基摩玩具犬',
      breedCode: 'american_eskimo_toy',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 62,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '玛尔济斯犬',
      breedCode: 'maltese',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/玛尔济斯犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 64,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美洲可卡犬',
      breedCode: 'american_cocker_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国可卡犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 81,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '马略卡獒犬',
      breedCode: 'majorca_mastiff',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 99,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你牛头梗',
      breedCode: 'miniature_bull_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/牛头梗-迷你.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 160,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你宾莎犬',
      breedCode: 'miniature_pinscher',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/小鹿犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 175,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '马雷马猎犬',
      breedCode: 'segugio_maremmano',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 192,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '秘鲁无毛小型犬',
      breedCode: 'peruvian_hairless_dog_small',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 219,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国水猎犬',
      breedCode: 'american_water_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国水猎犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 234,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '墨西哥无毛犬',
      breedCode: 'xoloitzcuintle',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 238,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你墨西哥无毛犬',
      breedCode: 'xoloitzcuintle_miniature',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 240,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国比特犬',
      breedCode: 'american_pit_bull_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/比特犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 242,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美洲英格兰浣熊猎犬',
      breedCode: 'american_english_coonhound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 245,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你美洲牧羊犬',
      breedCode: 'miniature_american_shepherd',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 250,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '马略卡牧羊犬',
      breedCode: 'majorca_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 265,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美洲狐狸猎犬',
      breedCode: 'american_foxhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国猎狐犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 279,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '曼彻斯特梗犬',
      breedCode: 'manchester_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/曼彻斯特梗.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 305,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '穆迪犬',
      breedCode: 'mudi',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 313,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你美洲爱斯基摩犬',
      breedCode: 'american_eskimo_miniature',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 321,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你贵宾犬',
      breedCode: 'poodle_miniature',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 345,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '马斯提夫犬',
      breedCode: 'mastiff',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/马士提夫犬.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 372,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国斯塔福郡梗',
      breedCode: 'american_staffordshire_terrier',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/美国史特富郡梗.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 386,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '马尔泰犬',
      breedCode: 'maltipoo',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 407,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美洲斗牛犬',
      breedCode: 'american_bulldog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 418,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '秘鲁无毛犬',
      breedCode: 'peruvian_hairless_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 463,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美洲豹猎犬',
      breedCode: 'american_leopard_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 533,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '迷你雪纳瑞',
      breedCode: 'miniature_schnauzer',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/雪纳瑞-迷你.png',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 543,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '美国秋田犬',
      breedCode: 'american_akita',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 563,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '玛瑞玛安布卢斯牧羊犬',
      breedCode: 'maremma_and_the_abbruzes_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'M',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  N: [
    {
      id: 129,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '挪威猎犬',
      breedCode: 'norwegian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 138,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '挪威伦德犬',
      breedCode: 'norwegian_lundehund',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 161,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '诺福克梗',
      breedCode: 'norfolk_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/罗福梗.png',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 280,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '诺波丹狐狸犬',
      breedCode: 'norrbottenspitz',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 294,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '挪威布哈德犬',
      breedCode: 'norwegian_buhund',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 346,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '纽芬兰犬',
      breedCode: 'newfoundland',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/纽芬兰犬.png',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 349,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '南俄牧羊犬',
      breedCode: 'south_russian_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 427,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '诺曼阿尔托西安獒犬',
      breedCode: 'norman_artesien_basset',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 468,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '尼韦尔格里芬犬',
      breedCode: 'griffon_nivernais',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 551,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '拿破仑獒犬',
      breedCode: 'neapolitan_mastiff',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 553,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '诺维茨梗',
      breedCode: 'norwich_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/罗威士梗.png',
      keywords: null,
      firstLetter: 'N',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  O: [
    {
      id: 152,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '欧洲大陆型兰德西尔犬',
      breedCode: 'landseer_european_continental_type',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'O',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 324,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '欧亚犬',
      breedCode: 'eurasian',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'O',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 423,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '欧式俄国莱卡犬',
      breedCode: 'russian_european_laika',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'O',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  P: [
    {
      id: 10,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '普罗旺斯小猎犬',
      breedCode: 'briquet_de_provence',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 33,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '皮卡第猎犬',
      breedCode: 'picardy_spaniel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 34,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '平毛狐狸梗',
      breedCode: 'fox_terrier_smooth',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/平毛猎狐梗.png',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 38,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '葡萄牙小猎犬',
      breedCode: 'portuguese_podengo_small',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 130,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '普德尔指示犬',
      breedCode: 'pudelpointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 163,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '平面皮耶瑞牧羊犬',
      breedCode: 'pyrenean_sheepdog_smooth_faced',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 193,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '普瓦图猎犬',
      breedCode: 'poitevin',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 258,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '普利犬',
      breedCode: 'puli',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/波利犬.png',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 275,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '葡萄牙牧羊犬',
      breedCode: 'portuguese_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 289,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '葡萄牙水犬',
      breedCode: 'portuguese_water_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/葡萄牙水犬.png',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 358,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '普米犬',
      breedCode: 'pumi',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/波密犬.png',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 371,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '葡萄牙指示犬',
      breedCode: 'portuguese_pointing_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 375,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '皮卡尔迪牧羊犬',
      breedCode: 'picardy_sheepdog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 387,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '普洛特猎犬',
      breedCode: 'plott_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 536,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '帕特大勒梗犬',
      breedCode: 'patterdale_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 570,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '帕森拉希尔梗',
      breedCode: 'parson_russell_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 576,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '平毛寻回犬',
      breedCode: 'flat_coated_retriever',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/平毛寻回犬.png',
      keywords: null,
      firstLetter: 'P',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  Q: [
    {
      id: 141,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '拳击犬',
      breedCode: 'boxer',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/拳师.png',
      keywords: null,
      firstLetter: 'Q',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 306,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '秋田犬345',
      breedCode: 'akita',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/秋田犬.png',
      keywords: null,
      firstLetter: 'Q',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 420,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '骑士查理王猎犬',
      breedCode: 'king_charles_spaniel',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/骑士查理王猎犬.png',
      keywords: null,
      firstLetter: 'Q',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 431,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '奇诺克犬',
      breedCode: 'chinook',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Q',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 557,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '切萨皮克湾寻回犬',
      breedCode: 'chesapeake_bay_retriever',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/乞沙比克猎犬.png',
      keywords: null,
      firstLetter: 'Q',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  R: [
    {
      id: 98,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '瑞士猎犬',
      breedCode: 'swiss_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 108,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '瑞典柯基犬',
      breedCode: 'swedish_vallhund',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 123,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '日本梗',
      breedCode: 'japanese_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 252,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '瑞典拉普猎犬',
      breedCode: 'swedish_lapphund',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/瑞典拉普杭犬.png',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 257,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '日本尖嘴犬',
      breedCode: 'japanese_spitz',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/银狐犬.png',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 311,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '瑞典白色猎鹿犬',
      breedCode: 'swedish_white_elkhound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 500,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '瑞典驯鹿犬',
      breedCode: 'jamthund',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 525,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '日本狮子狗',
      breedCode: 'japanese_chin',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/日本仲.png',
      keywords: null,
      firstLetter: 'R',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  S: [
    {
      id: 37,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '萨尔罗斯狼犬',
      breedCode: 'saarloos_wolfhond',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 42,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '苏格兰梗',
      breedCode: 'scottish_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/苏格兰梗.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 74,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯凯梗',
      breedCode: 'skye_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/斯凯梗.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 92,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯马兰猎犬',
      breedCode: 'smalandsstovare',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 95,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '萨摩耶犬',
      breedCode: 'samoyed',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/萨摩耶犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 104,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '塞尔维亚三色猎犬',
      breedCode: 'serbian_tricolor_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 156,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '四国犬',
      breedCode: 'shikoku',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 157,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '圣伯纳长毛犬',
      breedCode: 'st_bernard_longhaired',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 162,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯卢夫猎犬',
      breedCode: 'sloughi',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 172,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '树丛杂种犬',
      breedCode: 'treeing_cur',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 243,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '苏格兰牧羊犬',
      breedCode: 'collie_rough',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/苏格兰牧羊犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 348,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '圣伯纳犬',
      breedCode: 'st_bernard',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/圣伯纳犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 357,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯洛伐克刚毛指示犬',
      breedCode: 'wirehaired_slovakian_pointer',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/刚毛指示格里芬犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 373,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '萨路基犬',
      breedCode: 'saluki',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/萨路基.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 382,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯蒂芬斯猎犬',
      breedCode: 'stephens_cur',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 384,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '树丛行走浣熊猎犬',
      breedCode: 'treeing_walking_coonhound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 390,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '山猎犬',
      breedCode: 'mountain_cur',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 422,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '圣米格尔牧牛犬',
      breedCode: 'saint_miguel_cattle_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 429,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '史毕诺犬',
      breedCode: 'italian_spinone',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/史毕诺犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 430,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯塔比霍恩犬',
      breedCode: 'stabijhoun',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 433,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '塞尔维亚猎犬',
      breedCode: 'serbian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 439,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '水獺犬',
      breedCode: 'otterhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/奥达猎犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 451,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '沙皮狗',
      breedCode: 'shar_pei',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/中国沙皮犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 453,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '圣日尔曼指示犬',
      breedCode: 'saint_germain_pointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 459,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '塞利哈姆梗',
      breedCode: 'sealyham_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/西里汉梗.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 460,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '施韦兹猎犬',
      breedCode: 'schwyz_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 461,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '萨塞克斯猎犬',
      breedCode: 'sussex_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/塞式猎犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 486,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '松狮犬',
      breedCode: 'chow_chow',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/松狮犬.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 496,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯洛伐克猎犬',
      breedCode: 'slovakian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 514,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯洛伐克古瓦奇犬',
      breedCode: 'slovakian_chuvach',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 540,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '圣尤斯日猎犬',
      breedCode: 'epagneul_de_saint_usuge',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 549,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '圣伯纳犬短毛',
      breedCode: 'st_bernard_short_haired',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 562,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '斯塔福德郡斗牛梗',
      breedCode: 'staffordshire_bull_terrier',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/斯塔福郡斗牛梗.png',
      keywords: null,
      firstLetter: 'S',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  T: [
    {
      id: 3,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '泰迪罗斯福梗',
      breedCode: 'teddy_roosevelt_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 7,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '田纳西布林德猎犬',
      breedCode: 'treeing_tennessee_brindle',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 45,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '田野猎犬',
      breedCode: 'field_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/田野猎犬.png',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 109,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '提罗尔猎犬',
      breedCode: 'tyrolean_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 119,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '泰国班卡犬',
      breedCode: 'thai_bangkaew_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 253,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '泰国罗德尔犬',
      breedCode: 'thai_ridgeback_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 312,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '田特菲梗',
      breedCode: 'tenterfield_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 367,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '土佐犬',
      breedCode: 'tosa',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/土佐犬.png',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 424,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '塔特拉牧羊犬',
      breedCode: 'tatra_shepherd_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 435,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '台湾狗',
      breedCode: 'taiwan_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'T',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  W: [
    {
      id: 8,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威尔士猎犬',
      breedCode: 'welsh_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 93,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威尔士梗',
      breedCode: 'welsh_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/威尔士梗.png',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 115,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '乌拉圭犬',
      breedCode: 'cimarron_uruguayo',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 166,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '玩具猎狐梗',
      breedCode: 'toy_fox_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 336,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威尔士柯基犬',
      breedCode: 'welsh_corgi_pembroke',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/威尔士彭布洛克柯基.png',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 340,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威尔士柯基犬卡迪根',
      breedCode: 'welsh_corgi_cardigan',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/威尔士卡迪根柯基.png',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 380,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威玛猎犬',
      breedCode: 'weimaraner',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/魏玛犬.png',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 392,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '未定义犬种',
      breedCode: 'undefined',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 492,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '乌克苏犬',
      breedCode: 'u_cursinu',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 494,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威尔士春猎犬',
      breedCode: 'welsh_springer_spaniel',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/威尔斯激飞猎犬.png',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 537,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '玩具贵宾犬',
      breedCode: 'poodle_toy',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 572,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '威普犬',
      breedCode: 'whippet',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/惠比特.png',
      keywords: null,
      firstLetter: 'W',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  X: [
    {
      id: 70,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西高地白梗',
      breedCode: 'west_highland_white_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/西高地白梗.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 79,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '匈牙利刚毛指示犬',
      breedCode: 'hungarian_wire_haired_pointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 80,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型勃拉帮特格里芬犬',
      breedCode: 'petit_brabancon',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 107,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西班牙灵缇',
      breedCode: 'spanish_greyhound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 125,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小狮子犬',
      breedCode: 'little_lion_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/罗秦犬.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 198,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '希腊猎犬',
      breedCode: 'hellenic_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 206,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型蒙斯特兰德猎犬',
      breedCode: 'small_munsterlander_pointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 232,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西施犬',
      breedCode: 'shih_tzu',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/西施犬.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 237,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型加斯科尼圣东基犬',
      breedCode: 'gascon_saintongeois_small',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 254,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型朱拉猎犬',
      breedCode: 'small_jura_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 255,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西班牙猎犬',
      breedCode: 'spanish_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 276,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西班牙水犬',
      breedCode: 'spanish_water_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 277,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型蓝色加斯科涅猎犬',
      breedCode: 'petit_bleu_de_gascogne',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 281,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西法兰克达克斯布拉克犬',
      breedCode: 'westphalian_dachsbracke',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 284,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西西伯利亚莱卡犬',
      breedCode: 'west_siberian_laika',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 286,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型伯恩猎犬',
      breedCode: 'small_bernese_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 287,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '新斯科舍鸭猎犬',
      breedCode: 'nova_scotia_duck_tolling_retriever',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/新斯科舍猎鸭寻猎犬.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 317,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '匈牙利灵缇犬',
      breedCode: 'hungarian_greyhound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 320,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '匈牙利维兹拉犬',
      breedCode: 'hungarian_short_haired_pointer_vizsla',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 351,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '血猎犬',
      breedCode: 'bloodhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/寻血猎犬.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 360,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西西里猎犬',
      breedCode: 'cirneco_delletna',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 428,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '匈牙利猎犬',
      breedCode: 'hungarian_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 432,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '席勒猎犬',
      breedCode: 'schillerstovare',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 449,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型施韦兹猎犬',
      breedCode: 'small_schwyz_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 450,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型卢塞恩猎犬',
      breedCode: 'small_lucerne_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 501,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型瑞士猎犬',
      breedCode: 'small_swiss_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 515,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '小型格里芬文登犬',
      breedCode: 'petit_basset_griffon_vendeen',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/贝吉格里芬凡丁犬.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 518,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西伯利亚雪橇犬',
      breedCode: 'siberian_husky',
      thumbnailUrl:
        'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/哈士奇(西伯利亚雪橇犬).png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 527,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '谢特兰牧羊犬',
      breedCode: 'shetland_sheepdog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/喜乐蒂牧羊犬.png',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 567,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '西班牙獒犬',
      breedCode: 'spanish_mastiff',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'X',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  Y: [
    {
      id: 13,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英国牧羊犬',
      breedCode: 'english_shepherd',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 90,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '雅库特猎犬',
      breedCode: 'yakutian_laika',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 96,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伊斯特里亚刚毛猎犬',
      breedCode: 'istrian_wire_haired_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 97,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英格兰猎犬',
      breedCode: 'english_setter',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/英国雪达.png',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 148,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伊巴尼尔·蓬托德梅尔犬',
      breedCode: 'pont_audemer_spaniel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 173,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '约克混合贵宾犬',
      breedCode: 'yorkiepoo',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 199,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英国指示犬',
      breedCode: 'english_pointer',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 222,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英格兰玩具梗犬',
      breedCode: 'english_toy_terrier',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 249,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '意大利短毛猎犬',
      breedCode: 'italian_short_haired_segugio',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 263,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英格兰狐狸猎犬',
      breedCode: 'english_foxhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/英国猎狐犬.png',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 278,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '意大利狐狸犬',
      breedCode: 'italian_volpino',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 304,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '意大利灵缇犬',
      breedCode: 'italian_greyhound',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/意大利灵缇.png',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 309,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英俄猎犬',
      breedCode: 'anglo_russkaja_gontjaja',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 334,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '约克夏犬',
      breedCode: 'yorkshire_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/约克夏.png',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 1,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 368,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '意大利指示犬',
      breedCode: 'italian_pointing_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 462,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伊比赞猎犬',
      breedCode: 'ibizan_podenco',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 469,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '意大利粗毛猎犬',
      breedCode: 'italian_rough_haired_segugio',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 499,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '伊斯特里亚短毛猎犬',
      breedCode: 'istrian_short_haired_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 521,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英国可卡猎犬',
      breedCode: 'english_cocker_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/英国可卡犬.png',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 522,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '英格兰斯普林犬',
      breedCode: 'english_springer_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/英国史宾格犬.png',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 544,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '意大利卡恩科犬',
      breedCode: 'italian_corso_dog',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Y',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
  Z: [
    {
      id: 94,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '中华田园犬',
      breedCode: 'chinese_crested_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/中国冠毛犬.png',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 122,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '中型德国绒毛犬',
      breedCode: 'german_spitz_mittel',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 126,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '中型英法猎犬',
      breedCode: 'medium_sized_anglo_french_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 151,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '藏獒',
      breedCode: 'tibetan_mastiff',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/藏獒.png',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 153,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '中型墨西哥无毛犬',
      breedCode: 'xoloitzcuintle_intermediate',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 195,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '藏獒犬',
      breedCode: 'tibetan_spaniel',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/西藏猎犬.png',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 259,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '朱拉猎犬',
      breedCode: 'jura_hound',
      thumbnailUrl: '',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 3,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 350,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '中亚牧羊犬',
      breedCode: 'central_asia_shepherd_dog',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/中亚牧羊犬.png',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 4,
      lifeStageType: 0,
      lifeStages: null,
    },
    {
      id: 448,
      breedTypeName: null,
      breedTypeId: 2,
      breedName: '藏獒犬',
      breedCode: 'tibetan_terrier',
      thumbnailUrl: 'https://rccardstonenmkttest01.blob.core.chinacloudapi.cn/mallfiles/petBreed/dog/西藏梗.png',
      keywords: null,
      firstLetter: 'Z',
      isDisplay: true,
      creationDt: null,
      weight: 100,
      bodySize: 2,
      lifeStageType: 0,
      lifeStages: null,
    },
  ],
};

export default mockJson;
